<template>
    <div class="common_layout">
        <TopHeader title="訂單管理" :isfilter="1" :filterClick="filterClick"/>
        <div class="topBar" v-if="list.length > 0">
            <div>總收入</div>
            <div><span style="font-size:14px;margin-right:10px">CNY</span>{{allmoney}}</div>
        </div>
        <div v-if="list.length > 0" style="height:50px"></div>
        <div class="contentbox">
            <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
                <van-list
                v-model:loading="loading"
                :finished="finished"
                :finished-text="list.length > 0 ? '没有更多了' : ''"
                @load="onLoad"
                >

                    <div class="center_flex_layout" style="height: calc(100vh - 120px)" v-if="list.length === 0">
                        <div>
                            <div class="center_flex_layout">
                                <img
                                        style="width: 160px; height: 174px"
                                        src="../../assets/images/child_nondata_img.png"
                                />
                            </div>

                            <p
                                    class="common_font"
                                    style="color: #909399; margin-top: 20px; text-align: center"
                            >
                                暫無數據
                            </p>
                        </div>
                    </div>

                <div v-for="item in list" :key="item" class="order">
                    <div class="row">
                        <div class="left">訂單號</div>
                        <div class="right">{{item.id}}</div>
                    </div>
                    <div class="row">
                        <div class="left">子管理員</div>
                        <div class="right">{{item.username}}</div>
                    </div>
                    <div class="row">
                        <div class="left">創建時間</div>
                        <div class="right">{{dayjs(item.createTime).format('YYYY-MM-DD HH:mm:ss')}}</div>
                    </div>
                    <div class="row">
                        <div class="left">訂單狀態</div>
                        <div class="right">
                            <div class="righticon"
                                 :style="{
                                 borderColor: item.orderStatus == 1 ? 'rgba(103,194,58,0.5)' : item.orderStatus == 4 ? 'rgba(255,117,117,0.5)'
                                 : item.orderStatus == 5 ? 'rgba(255,184,0,0.5)' : item.orderStatus == 6 ? 'rgba(255,117,117,0.5)' : '#D9ECFF',
                                 backgroundColor: item.orderStatus == 1 ? 'rgba(103,194,58,0.2)' : item.orderStatus == 4 ? 'rgba(255,117,117,0.2)'
                                 : item.orderStatus == 5 ? 'rgba(255,184,0,0.2)' : item.orderStatus == 6 ? 'rgba(255,117,117,0.2)' : '#ECF5FF',
                                 color: item.orderStatus == 1 ? 'rgba(103,194,58,1)' : item.orderStatus == 4 ? 'rgba(255,117,117,1)'
                                 : item.orderStatus == 5 ? 'rgba(255,184,0,1)' : item.orderStatus == 6 ? 'rgba(255,117,117,1)' : '#409EFF',
                                 }"
                            >
                                {{item.orderStatus == 0?'待付款':
                                    item.orderStatus == 1?'已付款':
                                    item.orderStatus == 2?'已完成':
                                    item.orderStatus == 3?'已过期':
                                    item.orderStatus == 4?'已退款':
                                    item.orderStatus == 5?'退款中':
                                    item.orderStatus == 6?'退款失败':''
                                }}
                            </div>
                        </div>
                    </div>
                     <div class="row">
                        <div class="left">訂單總計</div>
                        <div class="right" style="justify-content:space-between">
                            <div class="money">
                                {{item.currency}} {{item.totalMoney}}
                            </div>
                            <div class="btn" @click="viewOrderDetail(item)">
                                查看詳情
                            </div>
                        </div>
                    </div>
                </div>
                </van-list>
            </van-pull-refresh>
        </div>
       <van-popup 
        v-model:show="show"
        closeable 
        :close-on-click-overlay="false"
        position="bottom"
        :style="{ maxHeight: '80%' ,overflow:'auto'}">
            <div class="popbox">
                <div class="toptitle">篩選</div>
                <div class="itemtitle">支付狀態</div>
                <div class="itemcheck">
                    <el-checkbox-group v-model="form.orderStatus" size="small">
                        <el-checkbox label="已付款" size="large" border/>
                        <el-checkbox label="退款成功，已取消" size="large" border />
                        <el-checkbox label="退款中" size="large" border />
                        <el-checkbox label="退款失敗" size="large" border />
                    </el-checkbox-group>
                </div>
                <div class="itemtitle">支付方式</div>
                <div class="itemcheck">
                    <el-checkbox-group v-model="form.payMethod" size="small">
                        <el-checkbox label="支付寶" size="large" border />
                        <el-checkbox label="微信支付" size="large" border />
                    </el-checkbox-group>
                </div>
                <div class="itemtitle" v-if="isManage">子管理員</div>
                <div class="itemcheck fullwidth" v-if="isManage">
                   <el-select v-model="form.userId" placeholder="請選擇子管理員" size="large">
                        <el-option
                            v-for="item in options"
                            :key="item.id"
                            :label="item.username"
                            :value="item.id"
                        />
                    </el-select>
                </div>
                <div class="itemtitle">訂單訊息</div>
                <div class="itemcheck ordertextrow">
                   <el-select v-model="form.type" placeholder="請選擇" size="large">
                        <el-option
                            v-for="item in typeOpitons"
                            :key="item.id"
                            :label="item.label"
                            :value="item.id"
                        />
                    </el-select>
                    <el-input type="tel" v-model="form.input" placeholder="請輸入" size="large"/>
                </div>
                <div class="itemtitle">選擇時間</div>
                <div class="itemcheck datewidth date_plate" :style="{opacity: form.start ? 1 : 0.6}">
                    <div @click="calendarshow = true">
                        <text v-if="form.start">
                            {{form.start}} - {{form.end}}
                        </text>
                        <text v-else>
                            请选择開始时间&nbsp;至&nbsp;請選擇結束時間
                        </text>
                    </div>
                </div>
                <div class="btnGroup">
                    <el-button size="large" @click="reset">重置</el-button>
                    <el-button type="primary" size="large" @click="search">确定</el-button>
                </div>
            </div>
        </van-popup>
        <van-calendar v-model:show="calendarshow" type="range" @confirm="onConfirm" :min-date="new Date(2010, 0, 1)" :max-date="new Date(2030, 0, 1)"/>
    </div>
</template>

<script setup>
    import { reactive, ref , onMounted, getCurrentInstance} from 'vue';
    import { get,post } from '../../utils/request';
    import { Encrypt } from '../../utils/secret'
    import { useRouter } from "vue-router";
    import dayjs from 'dayjs';
    const router = useRouter();

    const list = ref([]);
    const form = reactive({
        orderStatus:[],
        payMethod:[],
        userId:undefined,
        type:undefined,
        input:undefined,
        start:undefined,
        end:undefined
    })
    const searchfrom = reactive({
        orderStatus:[],
        payMethod:[],
    })
    const options = ref([])
    const isManage = ref(false)
    const loading = ref(false);
    const finished = ref(false);
    const refreshing = ref(false);
    const calendarshow = ref(false)
    const allmoney = ref(0)
    const show = ref(false);
    const page = ref(1)
    const size = ref(10)
    const total = ref(0)
    const typeOpitons = ref([
            {
                id:1,
                label:'訂單號',
            },
            {
                id:2,
                label:'手機號碼',
            },
        ]
    )
    onMounted(()=>{
        isManage.value = localStorage.getItem('role') == 'MANAGEMENT'?true:false
        if(isManage.value){
            getUserList()
        }
    })
    const formatDate = (date) => `${date.getMonth() + 1}/${date.getDate()}`;
    const getUserList = () =>{
        get('/manager/sub/account/list', {}, false).then(res=>{
            if(res.code == 1){
                options.value = res.result.list
                options.value.unshift({
                    id:0,
                    username:'全部子管理員'
                })
            }
        })
    }
    const showPopup = () => {
      show.value = true;
    };
    const onConfirm = (values)=>{
        const [start, end] = values;
        calendarshow.value = false;
        form.start = dayjs(start).format('YYYY-MM-DD HH:mm:ss')
        form.end = dayjs(end).format('YYYY-MM-DD HH:mm:ss')
    }
    const onLoad = () => {
        getlist(list.value.length === 0 ? 'init' : 'load')
        page.value = page.value + 1
    };
    const onRefresh = () => {
      list.value = []
      finished.value = false;
      loading.value = true;
      page.value = 1
      onLoad();
    };
    const getlist = (type)=>{
        let param = {
            page:page.value,
            size:size.value,
        }
        if(searchfrom.orderStatus.length){
            param ={
                ...param,
                orderStatus:searchfrom.orderStatus
            }
        }
        if(searchfrom.payMethod.length){
            param ={
                ...param,
                payMethod:searchfrom.payMethod
            }
        }
        if(searchfrom.mobile){
            param ={
                ...param,
                mobile:searchfrom.mobile
            }
        }
        if(searchfrom.orderId){
            param ={
                ...param,
                orderId:searchfrom.orderId
            }
        }
        if(searchfrom.startTime){
            param ={
                ...param,
                startTime:searchfrom.startTime
            }
        }
        if(searchfrom.endTime){
            param ={
                ...param,
                endTime:searchfrom.endTime
            }
        }
        if (searchfrom.userId) {
            param ={
                ...param,
                userId: searchfrom.userId
            }
        }
        if (!isManage.value) {
            param ={
                ...param,
                userId: localStorage.userId
            }
        }
        post(`/manager/order/list`, param, null, type === 'init' ? true : false)
            .then(res => {
                // console.log(JSON.stringify(res));
                if(res.code == 1){
                    if(param.page == 1){
                        list.value = res.result.list
                    }else{
                        list.value = list.value.concat(res.result.list)
                    }
                    loading.value = false
                    refreshing.value = false;
                    allmoney.value = res.result.theDayMoney
                    if(res.result.hasNext == false){
                        finished.value = true;
                    }else{
                        finished.value = false;
                    }
                }
            })
            .catch(error => {
                console.log(error);
            })
    }
    const filterClick = ()=>{
        showPopup()
    }
    const search = () =>{
        //回顶部
        window.scrollTo({
            top: 0,
            behavior: 'smooth' // 可以添加平滑滚动效果
        });
        //orderStatus
        searchfrom.orderStatus = []
        searchfrom.payMethod = []
        page.value = 1
        if(form.orderStatus.includes('已付款')){
            searchfrom.orderStatus.push('1')
        }
        if(form.orderStatus.includes('退款成功，已取消')){
            searchfrom.orderStatus.push('4')
        }
        if(form.orderStatus.includes('退款中')){
            searchfrom.orderStatus.push('5')
        }
        if(form.orderStatus.includes('退款失敗')){
            searchfrom.orderStatus.push('6')
        }
        //payMethod
         if(form.payMethod.includes('微信支付')){
            searchfrom.payMethod.push('weixin')
        }
        if(form.payMethod.includes('支付寶')){
            searchfrom.payMethod.push('alipay')
        }
        searchfrom.userId = form.userId
        if(form.type == 2){
            searchfrom.mobile = form.input
            searchfrom.orderId = ''
        }
        if(form.type == 1){
            searchfrom.mobile = ''
            searchfrom.orderId = form.input
        }
        searchfrom.startTime = form.start
        searchfrom.endTime = form.end
        show.value = false
        getlist('init')

    }
    const reset = () =>{
        form.orderStatus=[]
        form.payMethod=[]
        form.userId=undefined
        form.type=undefined
        form.input=undefined
        form.start=undefined
        form.end=undefined
        searchfrom.orderStatus=[]
        searchfrom.payMethod=[]
        searchfrom.userId=undefined
        searchfrom.mobile=undefined
        searchfrom.orderId=undefined
        searchfrom.startTime=undefined
        searchfrom.endTime=undefined
    };
    const viewOrderDetail =(data)=> {
        let orderId = encodeURIComponent(Encrypt(JSON.stringify(data.id)));
        router.push('/orderDetail?orderNum='+orderId);
    };
</script>

<style lang="less" scoped>
    .topBar{
        display: flex;
        align-items: center;
        justify-content: space-between;
        position: fixed;
        width: calc(100% - 32px);
        background-color: #ffffff;
        z-index: 99;
        padding-top: 20px;
        font-size: 18px;
        font-weight: 500;
        color: #000000;
    }
    .contentbox{
        padding:0px 4px;
        max-height: calc(100vh - 62px);
        .order{
            margin-top: 10px;
            box-sizing: border-box;
            border: 1px solid rgba(235, 238, 245, 1);
            border-bottom: 0px;
            .row{
                display: flex;
                align-items: center;
                border-bottom: 1px solid rgba(235, 238, 245, 1);
            }
            .left{
                width: 90px;
                height: 46px;
                background-color: rgba(245, 247, 250, 1);
                font-size: 14px;
                font-weight: 600;
                color: #606266;
                line-height: 46px;
                text-align: center;
            }
            .right{
                flex: 1;
                padding-left: 16px;
                padding-right: 8px;
                font-size: 14px;
                font-weight: 400;
                color: #606266;
                display: flex;
                align-items: center;
                .money{
                    font-size: 14px;
                    font-weight: 600;
                    color: #409EFF;
                }
                .btn{
                    width: 79px;
                    height: 32px;
                    background: #409EFF;
                    border-radius: 2px 2px 2px 2px;
                    font-size: 14px;
                    font-family: PingFang HK-Regular, PingFang HK;
                    font-weight: 400;
                    color: #FFFFFF;
                    line-height: 32px;
                    text-align: center;
                }
            }
            .righticon{
                padding: 0px 10px;
                width: max-content;
                background: #ECF5FF;
                border-radius: 4px 4px 4px 4px;
                opacity: 1;
                border: 1px solid #D9ECFF;
                font-size: 12px;
                font-weight: 400;
                color: #409EFF;
                height: 24px;
                line-height: 24px;
            }
        }
    }
    .van-list{
        height: 100%;
    }
    .popbox{
        padding: 16px;
        .toptitle{
            font-size: 18px;
            font-weight: 500;
            color: #303133;
        }
        .itemtitle{
            font-size: 14px;
            font-weight: 400;
            color: #303133;
            margin-top: 25px;
        }
        .itemcheck{
            margin-top: 5px;
        }
    }
    .el-checkbox{
        margin-bottom: 5px;
        margin-right: 10px;
    }
    .fullwidth{
         .el-select{
            width: 100%;
        }
        /deep/ .el-range-editor.el-input__wrapper{
            width:calc(100vw - 54px) !important;
        }
    }
    .datewidth{
        font-size: 14px;
        font-weight: 400;
        color: #303133;
        opacity: 0.6;
    }
    .date_plate {
        border-radius: 4px;
        border: 1px #dcdfe6 solid;
        padding: 10px;
    }
    .ordertextrow{
        display: flex;
        align-items: center;
        .el-select{
            width: 170px;
            margin-right: 10px;
        }
    }
    .btnGroup{
        display: flex;
        align-items: center;
        justify-content: flex-end;
        margin-top: 26px;
        margin-bottom: 22px;
    }
</style>